import makeStyles from '@mui/styles/makeStyles';

const claimReimbursementTabStyle = makeStyles(
  {
    reimbursementContainer: {
      marginBottom: '22px',
    },
    reimbursementTitle: {
      fontSize: '10px',
      lineHeight: '16px',
      letterSpacing: '1.5px',
      color: '#2196F3',
      marginBottom: '8px',
    },
    reimbursementSubtitle: {
      fontSize: '12px',
      fontWeight: '700',
      lineHeight: '16px',
      letterSpacing: '0.4px',
      color: '#000000',
      marginBottom: '8px',
    },
    reimbursementDetail: {
      fontSize: '10px',
      fontWeight: '400',
      lineHeight: '16px',
      letterSpacing: '0.4px',
      color: '#767676',
      marginBottom: '4px',
    },
    reimbursementDetailAmountPaid: {
      fontSize: '10px',
      fontWeight: '400',
      lineHeight: '16px',
      letterSpacing: '0.4px',
      color: '#767676',
      marginBottom: '16px',
    },
    financialReviewText: {
      color: '#D4424E',
      fontWeight: '500',
      fontSize: '10px',
      lineHeight: '16px',
      letterSpacing: '1.5px',
    },
    financialReviewIcon: { color: '#D4424E', width: '16px', marginRight: '4px' },
    financialReviewContainer: { display: 'flex', alignItems: 'center' },
  },
  { name: 'claim-reimbursement-tab' }
);

export { claimReimbursementTabStyle };
